import { render } from "./P064.vue?vue&type=template&id=752dcf32&scoped=true"
import script from "./P064.vue?vue&type=script&lang=js"
export * from "./P064.vue?vue&type=script&lang=js"

import "./P064.vue?vue&type=style&index=0&id=752dcf32&scoped=true&lang=css"

import exportComponent from "/home/sage/workspace/sageprice-dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-752dcf32"]])

export default __exports__